<template>
	<section>

		<mu-row class="sys_title">
			<mu-col width="15" tablet="15" desktop="15">&nbsp;</mu-col>
			<mu-col width="70" tablet="70" desktop="70" class="sys_title">
				<mu-row>
					<mu-col span="5">
						<mu-chip backgroundColor="rgba(255, 255, 255, 1)" style="marginTop:-8px">
							<mu-avatar backgroundColor="rgba(0,0,0,0)" :size="70"><img src="/static/img/logo.png" /></mu-avatar>
							<span style="font-size:2.2em;font-weight:bolder;color:#505050;">智慧济南时空大数据平台(公众版)</span>
						</mu-chip>
					</mu-col>
					<mu-col span="3"></mu-col>
					<mu-col span="4">
						<div backgroundColor="rgba(255, 255, 255, 1)" style=" color:#2363B5;  margin-top: -25px;padding:0 0;cursor: default">
							<template v-if="userInfo">
								<div class="user-detail">
									<span class="user-name" @click="openNewWindow(UserCenterLocation + '#0')">{{ username }}&nbsp;</span>
									|
									<span @click="openNewWindow(UserCenterLocation + '#1')">
										<span>
											&nbsp;我的消息&nbsp;
											<span class="user-count" v-if="userMsgCount">{{ '(' + userMsgCount + ')' }}&nbsp;</span>
										</span>
									</span>
									|
									<span @click="loginHelp">&nbsp;帮助中心</span>
									|
									<span @click="logout">&nbsp;注销登录</span>
								</div>
							</template>
							<template v-else>
								<div class="user-detail">当前用户：游客|登录</div>
							</template>
						</div>
					</mu-col>
				</mu-row>
			</mu-col>
			<mu-col width="15" tablet="15" desktop="15">&nbsp;</mu-col>
		</mu-row>

		<mu-row class="main_nav">
			<mu-col width="15" tablet="15" desktop="15">&nbsp;</mu-col>
			<mu-col width="70" tablet="70" desktop="70">
				<mu-tabs value="tab0" class="main_nav">
					<template v-for="(item, index) in modules">
						<mu-tab :title="item.name" :key="item.pkid" :index="item.pkid" @click="openNewWindow(item.href)" :value="setValue(index)"></mu-tab>
					</template>
				</mu-tabs>
			</mu-col>
			<mu-col width="15" tablet="15" desktop="15">&nbsp;</mu-col>
		</mu-row>
		<div class='doc'>

			<el-table id='forms' :data="helpDocs" border style="margin-left:800px;color:#0080FF;font-size:18px;">
				<el-table-column id="one" prop="name" label="文件名称" width="700px">
				</el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope" >
						<el-button @click="handleSee(scope.row)" class="see" round size="small" style="color:#0080FF;font-size:18px;">预览</el-button>
						<el-button  class="down"  round size="small"  style="color:#0080FF;font-size:18px;">
							<span id='links' @click="handleDown(scope.row)"  download='' style='color:#0080FF;'>下载</span>
						</el-button>
					</template>
				</el-table-column>
			</el-table>

		</div>
		<div class="foot" style="position: fixed;width: -webkit-fill-available;bottom: 0px; float:left;width:100%;">
			<div class="col-md-12 rows">
				<div class="footHrefOuter">
					<p class="footHref3" style="background: rgb(204, 204, 204); font-size: 12px;">
						<span>
							版权所有@ 2008-2018 济南市自然资源和规划局 技术支持：北京超图股份有限公司
						</span>
					</p>
				</div>
			</div>
		</div>
	</section>
</template>
<script type="text/javascript">
	import axios from 'axios';
	import $ from 'jquery';
	import {
		getUserMessage
	} from '@/apis/api';
	import {
		Geoesbmengine,
		Usercenter,
		Cas,
		Nav,
		Editmanager,
		Map,
		Webframe,
		dataThemesConfig
	} from '@/config/app-config';
	axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
	axios.defaults.withCredentials = true;
	let host = APPCONFIG.IP,
		casLogout = Cas.location + '/logout';
	export default {
		components: {},
		data() {
			return {
				modules: [],
				dataThemes: dataThemesConfig,
				usershortname: '游客',
				userMsgCount: 0,
				active: dataThemesConfig[0].theme,
				host: host,
				userid: '',
				userInfo: null,
				username: '游客',
				UserCenterLocation: Usercenter.location,
				EditManagerLocation: Editmanager.location,
				loginTextShow: true,
				supervisePoints: [],
				ThemesType: APPCONFIG.ThemesType,
				ThemesType1: APPCONFIG.ThemesType1,
				helpDocs: [],
			};
		},
		created() {
			setInterval(this.getUserMessage, 20000);
		},
		watch: {
			active(val) {
				this.getServicesInfo(val);
			},
		},
		methods: {
			loginHelp() {
				window.location.href = window.location;
			},
			//预览
			handleSee(row) {
				var num = row.name;
				for (var i = 0; i < this.helpDocs.length; i++) {
					var docs;
					if (this.helpDocs[i].name == num) {
						docs = this.helpDocs[i].content;
						if (docs.indexOf("&lt;span&gt;") != -1 && docs.indexOf("&lt;/span&gt;") != -1) {
							var str1 = docs.replace(/\&lt\;span\&gt\;/g, '');
							var str2 = str1.replace(/\&lt\;\/span\&gt\;/g, '');
							window.open(str2, '_blank', 'width='+(window.screen.availWidth-10)+',height='+(window.screen.availHeight-30)+ '');
						} else if (docs.indexOf("<span>") != -1) {
							var str3 = docs.replace(/\<span\>/g, '');
							var str = str3.replace(/\<\/span\>/g, '');
							window.open(str, '_blank', 'width='+(window.screen.availWidth-10)+',height='+(window.screen.availHeight-30)+ '');
						} else {                       
							var str = docs;            
							window.open(str, '_blank', 'width='+(window.screen.availWidth-10)+',height='+(window.screen.availHeight-30)+ '');
						}
					}
				}
			},
			//下载
			handleDown(row) {
				var num = row.name;
				for (var i = 0; i < this.helpDocs.length; i++) {
					var docs;
					if (this.helpDocs[i].name == num) {
						docs = this.helpDocs[i].content;
						if (docs.indexOf("&lt;span&gt;") != -1 && docs.indexOf("&lt;/span&gt;") != -1) {
							var str1 = docs.replace(/\&lt\;span\&gt\;/g, '');
							var str2 = str1.replace(/\&lt\;\/span\&gt\;/g, '');
							var str3 = str2.substring(0,str2.lastIndexOf('pdf')) +'doc';
							window.open(str3,'_blank');
						 	document.getElementById("links").download = num;
						} else if (docs.indexOf("<span>") != -1) {
							var str3 = docs.replace(/\<span\>/g, '');
							var str = str3.replace(/\<\/span\>/g, '');
							var url = str.substring(0,str.lastIndexOf('pdf')) +'doc';
							window.open(url,'_blank');
							document.getElementById("links").download = num;
						} else {
							var str = docs.substring(0,docs.lastIndexOf('pdf')) +'doc';;
							window.open(str,'_blank');
							document.getElementById("links").download = num;
						}
					}
				}
			},
			getUserInfo() {
				let that = this;
				axios.get(APPCONFIG.GetUserInfoUrl).then(function(e) {
					if (e.data && e.data.resultInfo) {
						that.userInfo = e.data.resultInfo.data;
						that.userid = e.data.resultInfo.data.pkid;
						that.username = e.data.resultInfo.data.usershortname;
						that.loginTextShow = false;
						that.getMapModule(that.userid);
					}
				});
			},
			openNewWindow(location) {
				if (location.indexOf('no_no') > -1) {
					alert('功能完善中...');
				} else {
					window.open(location, '_blank');
				}
			},
			setValue(index) {
				return 'tab' + index;
			},
			getUserMessage() {
				if (this.userInfo) {
					getUserMessage().then(res => {
						let result = res.data.resultInfo;
						if (result.success) {
							let count = result.data.sum;
							if (count > 99) {
								this.userMsgCount = '99+';
							} else {
								this.userMsgCount = count;
							}
						}
					});
				}
			},
			getMapModule(id) {
				let that = this;
				axios.get(APPCONFIG.GetMoudlesUrl + id + '.json').then(function(e) {
					if (e.data && e.data.data) {
						that.modules = e.data.data.modules[0].children[0].children;
					}
				});
			},
			scrollHtml(len) {
				var h = $(window).scrollTop(); //获取当前滚动条距离顶部的位置
				$('html,body').animate({
					scrollTop: document.getElementById(len).offsetTop - 50
				}, 800); //点击按钮向下移动800px，时间为800毫秒
			},
			getServicesInfo(themeId) {
				var that = this;
				axios.get(APPCONFIG.GetServicesUrl + '?pagesize=10&pageindex=1&specCode=' + themeId).then(function(e) {
					if (e.data && e.data.resultInfo) {
						that.servicesInfos = e.data.resultInfo.data.items;
						if (that.servicesInfos.length > 4) that.servicesInfos.length = 4;
					}
				});
			},
			returnStyle(url) {
				return 'background: url(' + url + ') no-repeat';
			},
			logout() {
				let url = this.userInfo ? casLogout + '?userid=' + this.userInfo.pkid : casLogout;
				window.location.href = url;
			},
		},
		mounted() {
			let that = this;
			this.getUserInfo();
			this.getServicesInfo(dataThemesConfig[0].theme);
			//获取文档信息
			axios.get(APPCONFIG.GetHelpsUrl).then(
				function(e) {
					let getHelps = e.data.resultInfo.data.items;
					that.helpDocs = [];
					for (var i = 0; i < getHelps.length; i++) {
						that.helpDocs.push({
							content: getHelps[i].ntcontent,
							name: getHelps[i].nttitle,
							data: getHelps[i].ntdate,
						});
					};

				});
		}
	};
</script>
<style type="text/css">
	th{
		background-color: #5099EA!important;
		color:white!important;
	}
	td{
		
		
	}
	a{
		color:#0080FF;
	}

	.is-leaf{
		background-color: #5099EA;
	}
	.see:link{
		color:#0080FF;
	}
	
	.doc {
		width: 60%;
		display: flex;
		flex-direction: column;
		justify-content: space-around;
		align-items: center;
		margin-top: 50px;
	}
	.themesName {
		position: absolute;
		bottom: 30%;
		left: 1.5%;
		color: white;
		width: 81%;
		height: 25%;
		background-color: rgba(128, 128, 128, 0.8);
		font-size: 23px;
		font-weight: bold;
		padding-left: 5%;
		padding-top: 2%;
	}

	.themesInfo {
		padding-left: 4%;
	}

	.media-body p {
		font-size: 14px;
	}



	/*--------------------------------------------------------------------*/
	.mu-tab-active {
		color: red !important;
	}

	body {
		min-width: 1910px;
		overflow-x: auto !important;
	}

	.user-detail span {
		cursor: pointer;
	}

	.card-back-url {
		padding: 10px;
	}

	#app .foot div .footHrefOuter .footHref3 {
		text-align: center;
		height: 30px;
		line-height: 30px;
	}

	.erweima {
		margin-top: 25px;
		padding: 10px 10px 10px 0;
	}

	.liaojiedesc {
		margin-top: 25px;
		background-color: #ffcd74;
		width: 130px;
		text-align: center;
		color: #fff;
		cursor: pointer;
		font-size: 24px;
		font-weight: 900;
		border-radius: 5px;
		box-shadow: 0 0 5px 5px #888888;
	}

	.mu-card-header {
		cursor: pointer;
	}

	.textdesc ul li {
		color: #fff;
		font-size: 18px;
		padding: 8px;
	}

	.textdesc h5 {
		font-size: 20px;
		color: #fff;
	}

	.textdesc {
		margin-top: 50px;
	}

	.finger {
		background: url(/static/img/finger.png) no-repeat;
		height: 532px;
	}

	.phone-title {
		text-align: center;
		font-weight: 900;
		font-size: 25px;
		color: #fff;
		height: 80px;
		line-height: 100px;
		border-bottom: 5px solid #fff;
	}
	.el-divider__text {
		font-size: 25px !important;
		font-weight: 900 !important;
		color: #ff5a69 !important;
		font-family: inherit !important;
		font-weight: 500 !important;
		line-height: 1.1 !important;
	}

	.sys_pingtai {
		height: 265px;
		padding: 20px 0;
		margin-top: 10px;
	}

	.el-input-group__append {
		border-left: 1px solid #dcdfe6 !important;
		background-color: #5099ea !important;
		color: #fff !important;
		border-radius: 25px !important;
		padding: 0 5px !important;
	}

	#nav_col_img .mu-card-header-title {
		vertical-align: inherit;
	}

	.nav_3_img .mu-card-header {
		text-align: center;
	}

	.nav_3_img .mu-card-header .mu-avatar img {
		border-radius: 1%;
	}

	.nav_3_img .mu-card-header .mu-card-header-title {
		padding-right: 18px;
		border-radius: 1%;
		display: block;
		text-align: center;
	}

	.el-input__inner {
		border-radius: 25px !important;
		height: 30px !important;
		line-height: 30px !important;
	}

	.mu-card-header-title .mu-card-title {
		font-size: 18px;
	}

	.mu-tab-link-highlight {
		border-radius: 25px;
		height: 3px;
		/* background-color: #fff;*/
	}
</style>
<style scoped>
	.mu-tab-link {
		border-bottom: 3px rgba(0, 0, 0, 0) solid;
	}

	.mu-tab-link:hover {
		border-bottom: 3px red solid;
		transition: transform 0.3s, opacity 0.3s;
	}

	#nav_4_img .mu-card-header .mu-avatar img {
		border-radius: 1%;
	}

	#nav_col_img .mu-card-header .mu-avatar img {
		border-radius: 20%;
		width: 50px;
		height: 50px;
	}

	.el-button {
		color: #fff;
		border-radius: 25px;
	}

	.el-input {
		padding: 5px;
		width: 98%;
		/*background-color: #7572728a;
    border: 1px solid #8c7e7e;*/
		border-radius: 25px;
		caret-color: #fff;
	}

	.sys_title {
		background: url('/static/img/top-pic.png') no-repeat center top;

		height: 95px;
		margin-top: 20px;
	}

	.username {
		float: left;
	}

	.bar-name {
		color: white;
	}

	.row-left {
		border-right: 1px dashed rgba(0, 0, 0, 0.1);
	}

	.menu-active {
		border-left: 2px solid lightblue;
	}

	.board-left,
	.board-right {
		padding: 5px;
	}

	.paper-draft {
		padding: 10px;
	}

	.list-menu {
		background: #eeeeee;
	}

	.sys_header,
	.header_user {
		background-color: #fff;
		color: #4e2594;
		height: 78px;
	}

	.sys_header .mu-paper-1 {
		box-shadow: none;
		line-height: 32px;
	}

	.sys_header .mu-tab-active {
		color: #333;
	}

	.sys_header .mu-tab-link {
		color: rgba(12, 67, 95, 0.7);
	}

	.sys_header_tabs {
		width: 50%;
	}

	.sys_banner {
		height: 54vh;

		background-color: #83aedb;
		text-align: center;
	}

	.sys_banner img {
		height: 100%;
	}

	.banner_nav {
		height: 60px;
		font-size: 33px;
	}

	.banner_bottom {
		margin-top: -10px;
		background-color: #83aedb;
	}

	.head_sub_nav {
		background-color: #fff;
		padding: 4px auto;
	}

	.left {
		flaot: left;
	}

	.main_nav {
		height: 50px;
		font-size: 20px;
		background-color: #5099ea;
	}

	.main_nav .mu-tab-text {
		color: #fff;
	}

	.banner_nav_col {
		padding: 20px 0px;
	}

	.service_nav {
		background-color: #fff;
		color: #4e2594;
	}

	.service_nav .mu-tab-link {
		color: #666;
	}

	.main_nav .mu-tab-link {
		font-size: 16px;
	}

	.service_tabs_content.mu-paper-1,
	.no_shadow {
		background-color: rgba(0, 0, 0, 0) !important;
		box-shadow: none;
		line-height: 32px;
	}

	.service_tabs_content.mu-paper-1 .service_item {
		width: 20%;
		float: left;
		cursor: pointer;
		margin: 0 2.5%;
	}

	.service_tabs_content.mu-paper-1 .service_item:hover {
		width: 20%;
		float: left;
		cursor: pointer;

		height: 95%;
		margin: 0 2.5%;
		margin-top: -2px;
		box-shadow: 0 10px 10px 10px #888888;
	}

	.bg_h {
		padding: 20px 0px;
		/*  background-color: #fff*/
	}
</style>



// WEBPACK FOOTER //
// help.vue?7c65cf71